const asyncUserRoutes = {
  path: 'user/list',
  component: () => import('@/views/system/users/index'),
  funcPerms: 'system:setting:users',
  name: 'auth-users',
  meta: {
    title: '用户管理',
    // icon: 'el-icon-user',
    icon: 'index',
    affix: false,
    noCache: true
  }
}

export default asyncUserRoutes
